<template>
  <el-container style="height: 100%">
    <el-aside width="170px">
      <el-menu
        router
        :default-active="activeItem"
        background-color="#efefef"
        style="height: 100%; overflow-x: hidden; color: #fff"
        :unique-opened="true"
      >
        <div class="left-menu">
          <div
            v-for="item in menuData"
            v-if="item.show"
            :key="item.path"
            :class="{
              'menu-item': item.hasChild == false,
              'item-is-active':
                currentPath == item.path && item.hasChild == false,
              'menu-item-submenu': item.hasChild == true,
            }"
          >
            <router-link
              v-if="item.hasChild == false"
              class="menu-item-title"
              :to="item.path"
              tag="div"
              active-class="is-active"
            >
              <i :class="item.clas"></i>{{ item.title }}
            </router-link>
            <div v-if="item.hasChild == true">
              <div
                class="submenu-label"
                style="position: relative"
                @click="selectCollapse(item.name)"
              >
                <i :class="item.clas"></i><span>{{ item.title }}</span>
                <i
                  class="el-icon-arrow-down"
                  style="
                    position: absolute;
                    right: 12px;
                    top: 14px;
                    padding: 0 !important;
                    transition: transform 0.3s;
                  "
                  :class="{
                    'arrow-down':
                      currentCollapse == item.name && !!openCollapse,
                  }"
                ></i>
              </div>
              <el-collapse-transition
                v-for="itemChild in item.childMenuData"
                :key="itemChild.path"
              >
                <div v-show="currentCollapse == item.name">
                  <div
                    v-if="itemChild.show"
                    class="transition-box"
                    :class="{
                      'submenu-item-is-active': currentPath == itemChild.path,
                    }"
                  >
                    <router-link
                      class="submenu-item-title"
                      :to="itemChild.path"
                      tag="div"
                      active-class="is-active"
                    >
                      {{ itemChild.childTitle }}
                    </router-link>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </div>
        </div>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<style lang="scss">
.el-aside {
  .el-menu {
    .left-menu {
      .menu-item,
      .menu-item-submenu {
        color: #444 !important;
        cursor: pointer;
        box-sizing: border-box;
        transition: 0.5s !important;
        -moz-transition: 0.5s !important; /* Firefox 4 */
        -webkit-transition: 0.5s !important; /* Safari and Chrome */
        -o-transition: 0.5s !important; /* Opera */
        font-size: 12px;
        font-weight: bold;
        border-bottom: 1px solid #ddd;
      }
      .menu-item,
      .menu-item-submenu .submenu-label,
      .transition-box {
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
      }
      .menu-item,
      .menu-item-submenu .submenu-label {
        padding-left: 30px !important;
      }

      .menu-item-submenu:hover {
        background-color: #ccc !important;
      }
      .transition-box {
        padding-left: 65px !important;
        transition: 0.5s !important;
        -moz-transition: 0.5s !important; /* Firefox 4 */
        -webkit-transition: 0.5s !important; /* Safari and Chrome */
        -o-transition: 0.5s !important; /* Opera */
        border-top: 1px solid #ddd;
        &:hover {
          color: #000 !important;
          background-color: #ddd !important;
          i {
            color: #000;
          }
        }
      }

      .item-is-active,
      .submenu-item-is-active {
        color: #000 !important;
        background-color: #ccc !important;
      }
      .arrow-down {
        transform: rotate(180deg);
      }
      .menu-item:hover {
        color: #000 !important;
        background-color: #ccc !important;
        i {
          color: #000;
        }
      }
      i {
        color: #444;
        padding-right: 8px !important;
        font-size: 14px;
      }
    }
  }
}
.el-main {
  padding: 0 !important;
  .el-breadcrumb {
    height: 40px;
    line-height: 40px !important;
    padding-left: 20px;
    border-bottom: 1px solid #ddd;
    box-sizing: border-box;
    background-color: rgba(239, 239, 239, 0.5);
  }
  .el-pagination {
    li,
    .btn-prev,
    .btn-next {
      margin: 0 2px;
      border: 1px solid rgb(209, 219, 229);
      color: rgb(72, 87, 106);
      font-weight: normal;
    }
    li {
      &:hover {
        color: #1b93ed;
        font-weight: bold;
      }
      &.active {
        color: #fff !important;
        font-weight: bold;
        background-color: #1b93ed;
      }
      &.active + li {
        border-left: 1px solid rgb(209, 219, 229);
      }
    }
    .btn-prev {
      padding-right: 6px;
      &:disabled {
        color: #c0c4cc !important;
      }
    }
    .btn-next {
      padding-left: 6px;
      &:disabled {
        color: #c0c4cc !important;
      }
    }
  }
  .el-table {
    .cell {
      white-space: nowrap;
      font-size: 12px;
    }
    .el-button {
      padding: 0;
      font-size: 12px;
    }
    thead {
      th {
        background-color: #f6f7f9;
        color: #666666;
        padding: 8px 0 !important;
      }
    }
    .el-table__body-wrapper {
      overflow-x: auto;
      .el-table__body {
        td {
          padding: 5px 0 !important;
        }
      }
    }
  }
  .el-button--primary {
    color: #fff;
    background-color: rgba(52, 126, 188, 1);
    border-color: rgba(52, 126, 188, 1);
    &:hover {
      background-color: rgba(52, 126, 188, 0.8);
      border-color: rgba(52, 126, 188, 0.8);
    }
  }
}
</style>

<script>
// import ElSubmenu from "../../../node_modules/element-ui/packages/menu/src/submenu.vue";
// 从node_modules里有引用的组件若不用需要注释掉，否则在IE下打不开页面，因为引用的这个东西没有用babel-polyfill解析掉
export default {
  // components: {ElSubmenu},
  data() {
    let role = window.localStorage.getItem("role");
    return {
      activeItem: "/statis",
      currentPath: this.$route.path,
      role: role,
      currentCollapse: false,
      openCollapse: false,
      menuData: [
        // {title: '首页', path: '/overview', name: 'overview', clas:'iconfont icon-shouye2', show: true, hasChild: false, childMenuData: []},
        {
          title: "设备列表",
          path: "/list",
          name: "list",
          clas: "iconfont icon-shebeiliebiao",
          show: true,
          hasChild: false,
          childMenuData: [],
        },
        {
          title: "锁厂管理",
          path: "/factory",
          name: "factory",
          clas: "iconfont icon-shebeiguanli1",
          show: role == "admin",
          hasChild: false,
          childMenuData: [],
        },

        {
          title: "产品管理",
          path: "/product",
          name: "product",
          clas: "iconfont icon-chanpinguanli1",
          show: true,
          hasChild: false,
          childMenuData: [],
        },
        {
          title: "固件管理",
          path: "/firmware",
          name: "firmware",
          clas: "el-icon-upload",
          show: role == "admin",
          hasChild: false,
          childMenuData: [],
        },

        // {title: '数据报表', path: '/device/analysis', name: 'deviceAnalysis', clas:'iconfont icon-shujutongji', show: true, hasChild: true, childMenuData: [
        //   {childTitle: '设备分析', path: '/device/analysis',name: 'deviceAnalysis', show: true},
        //   {childTitle: '收入分析', path: '/income/analysis',name: 'incomeAnalysis', show: true},
        //   {childTitle: '用水分析', path: '/water/analysis',name: 'waterAnalysis', show: true},
        // ]},
      ],
    };
  },
  watch: {
    $route: "routerChanged", //监控路由的变化，变化时执行routerChanged方法
  },
  computed: {},
  mounted() {
    this.activeItem = this.$route.path;
  },
  methods: {
    selectCollapse(currentCollapse) {
      if (this.openCollapse) {
        if (this.openCollapse == currentCollapse) {
          this.currentCollapse = false;
          this.openCollapse = false;
        } else {
          this.currentCollapse = currentCollapse;
          this.openCollapse = currentCollapse;
        }
      } else {
        this.currentCollapse = currentCollapse;
        this.openCollapse = currentCollapse;
      }
    },
    routerChanged() {
      this.currentPath = this.$route.path;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/ContainerWithMenu.vue